import gql from 'graphql-tag'

export default gql`
  mutation saveGitHubToken($code: String!) {
    saveGitHubToken(code: $code) {
      success
      errorText
      resData {
        githubAccounts {
          login
          avatar
        }
      }
    }
  }
`
